export default "__VITE_ASSET__7949c44b__"